import useSwr from 'swr'

export const useOtherArticlesByCategory = (category) => {
  const { data, error } = useSwr(
    `/jsonapi/v1/articles?filter[nin_category]=${category}&page[limit]=6`,
  )

  return {
    otherArticlesByCategory: data,
    error,
  }
}
